<script setup>
    import {reactive} from "vue";

    const {
        activeLanguage,
        langDropDown,
        otherCountriesText,
        wpmlLanguages,
    } = reactive(LANGDROPDOWN)

    /**
     * Builds the anchor link for a language selection
     * to retain any query parameters on the page for
     * UTM or otherwise, and append the language code
     * to the end if it exists
     *
     * @param {String} link The link to extract from
     * @returns {{String}|`${string}?${string}`}
     */
    const buildLink = (link) => {
        // Get the query strings from the current URL and the provided link
        const currentQuery = new URLSearchParams(window.location.search);
        const linkQuery = new URLSearchParams(new URL(link).search);

        // Remove the 'lang' parameter from the current query
        currentQuery.delete('lang');

        // Convert currentQuery to a string
        const queryString = currentQuery.toString();

        // If there's a query string to add, determine the correct separator ('?' or '&')
        const separator = linkQuery.toString() ? '&' : '?';

        return queryString ? `${link}${separator}${queryString}` : link;
    };

</script>

<template>
    <!-- Language dropdown component -->
    <div class="lang-dd">
        <button
            aria-expanded="false"
            aria-controls="lang-dd"
        >
            <span
                v-if="activeLanguage?.country_flag_url"
                class="flag-img"
            >
                <!-- Display selected flag image -->
                <img :src="activeLanguage?.country_flag_url"
                     :alt="`${activeLanguage?.native_name || ''} Flag`">
            </span>
            <span
                class="lang-letter-code"
                v-html="activeLanguage?.tagCode || ''"
            />
            <span class="icon" />
        </button>

        <ul
            id="lang-dd"
            aria-hidden="true"
            class="lang-submenu"
        >
            <!-- Loop through language groups -->
            <li v-for="items in langDropDown || []">
                <p
                    class="header-continent"
                    v-html="items?.language_group_title"
                />

                <ul
                    v-if="items.country_languages"
                    class="list-countries"
                >
                    <li v-for="language in items.country_languages">
                        <p
                            class="header-country"
                            v-html="language?.country"
                        />

                        <ul
                            v-if="language?.language_selection"
                            class="list-languages"
                        >
                            <li
                                v-for="lang in language?.language_selection"
                                class="lang_li"
                                data-img="image"
                            >
                                <a :href="buildLink(wpmlLanguages[lang].url)"
                                   v-html="wpmlLanguages[lang].native_name" />
                            </li>
                        </ul>

                    </li>
                </ul>

            </li>

            <li v-if="otherCountriesText"
                id="more-countries"
                class="more-countries">
                <button v-html="otherCountriesText"></button>
            </li>

        </ul>
    </div>
</template>

<script>
    export default {
        name: "Language Dropdown"
    }
</script>

<style scoped lang="scss">
    .lang-letter-code {
        margin-left: 5px;
        font-weight: bold;
        text-transform: capitalize;
    }
</style>
